import { createHmac } from 'crypto';

export const HMAC = ({ hmacKey }, data) => {
  const hmac = createHmac('sha256', hmacKey);
  return hmac.update(data).digest();
};
